import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import UserService from "../../services/User.service";

let cachedUsers = null;

/**
 * Simple autocomplete for picking an employee from the full employee list
 * (fetched once and cached, since the employee list is small).
 */
export default function EmployeePicker({
    value,
    onChange,
    label = "Employee",
    disabled = false,
    error = "",
    size = "medium",
}) {
    const [options, setOptions] = useState(cachedUsers || []);
    const [loading, setLoading] = useState(!cachedUsers);

    useEffect(() => {
        if (cachedUsers) return;
        setLoading(true);
        UserService.list()
            .then((res) => {
                const results = Array.isArray(res.data)
                    ? res.data
                    : (res.data?.results ?? []);
                const active = results.filter(
                    (u) => u.is_active !== false && u.user_type === "employee",
                );
                cachedUsers = active;
                setOptions(active);
            })
            .catch(() => setOptions([]))
            .finally(() => setLoading(false));
    }, []);

    const getLabel = (opt) =>
        opt ? opt.full_name || `${opt.first_name || ""} ${opt.last_name || ""}`.trim() || opt.username || "" : "";

    return (
        <Autocomplete
            options={options}
            value={value}
            onChange={(_, newVal) => onChange(newVal)}
            getOptionLabel={getLabel}
            isOptionEqualToValue={(opt, val) => opt.id === val?.id}
            loading={loading}
            disabled={disabled}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    size={size}
                    error={Boolean(error)}
                    helperText={error || ""}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading && <CircularProgress size={18} />}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
}
